module.exports = __webpack_public_path__ + "img/0Q3B3814-26_H_WoodMatted_MockedUp.0cb1b3f4.jpg";